
import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "advertiser";
const options = {role: ROLE.ADVERTISER};

export const OrderPayment = async (values) => {
  return await axiosInstance(options).post(`${path}/payment/order`, values);
};

export const VerifyPayment = async (value) => {
  return await axiosInstance(options).post(`${path}/payment/verify`,value);
}









